import React from "react";
import ComingSoon from "../common/ComingSoon";

function Webinars({ theme }) {
  return <ComingSoon theme={theme} />;
}

export default Webinars;
